import thumbnailImg from 'Static/thumbnails/screenshot--simple-machines.png';

export default {
  slug: 'simple-machines',
  title: 'Simple Machines',
  seriesNumber: '4',
  published: true,
  thumbnailImg,
  subject: 'Physical Sciences',
  graphicFileName: 'Image_SimpleMachines.png',
  graphicAlt:
    'App screenshot of Simple Machines depicting a castle and a lever',
  iconFileName: 'Icon_SimpleMachines.png',
  iconLargeFileName: 'Icon_SimpleMachines@2x.png',
  iconAlt:
    'App icon for Simple Machines depicting a lever and a guy on a scooter',
  description:
    'Topics covered include simple machines, physics, cause and effect, levers, pulleys, inclined planes, screws, wedges, and levers.',
  briefDescription: 'Learn about physics.',
  supportedLanguages: [
    'en',
    'af',
    'ar',
    'bg',
    'bn',
    'ca',
    'cs',
    'da',
    'de',
    'el',
    'es',
    'et',
    'fa',
    'fi',
    'fl',
    'fr',
    'he',
    'hi',
    'hr',
    'ht',
    'hu',
    'id',
    'is',
    'it',
    'ja',
    'km',
    'ko',
    'ms',
    'nb',
    'nl',
    'pa',
    'pl',
    'pt',
    'ro',
    'ru',
    'sr',
    'sv',
    'th',
    'tl',
    'tr',
    'uk',
    'ur',
    'vi',
    'zh-Hans',
    'zh-Hant',
  ],
  scenes: [
    'Menu',
    'Test_Lever',
    'Test_Lever_SliderOpen',
    'Test_Wheel',
    'Test_Wheel_SliderOpen',
    'Test_Pulley',
    'Test_Pulley_SliderOpen',
    'Test_InclinedPlane',
    'Test_InclinedPlane_SliderOpen',
    'Test_Screw',
    'Test_Screw_SliderOpen',
    'Test_Wedge',
    'Test_Wedge_SliderOpen',
  ],
  featuredPrintables: ['simple_machines_wheel_axle'],
  printables: [
    'simple_machines_pulley',
    'simple_machines_screw',
    'simple_machines_lever',
    'simple_machines_wedge',
    'simple_machines_inclined_plane',
    'concept_map',
    'generating_questions',
  ],
  topics: [
    'force_and_motion',
    'problem_solving_and_engineering',
    'comparing_and_testing_designs',
    'input_and_output_forces',
  ],
  deepLinks: {
    lever: 'Test_Lever',
    pulley: 'Test_Pulley',
    'wheel-and-axle': 'Test_Wheel',
    wedge: 'Test_Wedge',
    screw: 'Test_Screw',
    'inclined-plane': 'Test_InclinedPlane',
  },
  appLinks: {
    appStoreLink:
      'https://apps.apple.com/us/app/simple-machines-by-tinybop/id936966570',
    googlePlayLink:
      'https://play.google.com/store/apps/details?id=com.tinybop.machines',
    microsoftLink:
      'https://www.microsoft.com/en-us/p/simple-machines-by-tinybop/9nb5j68drqsn?activetab=pivot:overviewtab',
  },
};
